import React from 'react'
import PropTypes from 'prop-types'
import { Button, Flex } from '../UI'

// make true to display a visible edit link

// on live site, use this bookmarklet that creates the link from the hidden div
// javascript: var domEl = document.querySelector('[data-contentful_id]'); var contentful_id = domEl.dataset.contentful_id; if(contentful_id)window.open(`https://app.contentful.com/spaces/bki8s3rufpd7/entries/${contentful_id}`);

const IS_VISIBLE = process.env.NODE_ENV !== 'production'

const ContentfulEdit = ({ id }) => {
  const link = `https://app.contentful.com/spaces/bki8s3rufpd7/entries/${id}`
  return IS_VISIBLE ? (
    <Flex data-contentful_id={id} alignItems="start">
      <Button small as="a" href={link} target="_blank" rel="noreferrer">
        Edit
      </Button>
    </Flex>
  ) : (
    <div data-contentful_id={id} />
  )
}

ContentfulEdit.propTypes = {
  id: PropTypes.string,
}

export default ContentfulEdit
